export const useModifierGroup = (group, displaySettings) => {
    const { modifierGroupDescription = true } = displaySettings || {};
    const description = modifierGroupDescription && group.description ? group.description : null;
    const { quantity, min, max, included } = group;
    const belowMin = quantity < min;
    const suffix = min && belowMin
        ? `, ${min} required`
        : included && quantity < included
            ? `, ${included} included`
            : '';
    const count = `${quantity}${max ? `/${max}` : ' selected'}${suffix}`;
    return Object.assign(Object.assign({}, group), { description, count });
};
